import {DateTime} from 'luxon';
import {shouldShowMaybeRSVPFilter} from '~/common/utils/event_utils';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

const GuestRsvpButton = ({rsvpStatus, setWipRsvpStatus, setRsvpOverlayOpen}) => (
  <Button
    variant="primary"
    fullWidth
    data-qa-id={`response-${rsvpStatus.toLowerCase()}-rsvp`}
    size="large"
    className="view-invitation__rsvp-cta"
    onClick={() => {
      setWipRsvpStatus(rsvpStatus);
      setRsvpOverlayOpen(true);
    }}
  >
    {rsvpStatus}
  </Button>
);

const GuestRsvpOriginalButtons = ({
  setWipRsvpStatus,
  setRsvpOverlayOpen,
  origin,
  allowMaybeRSVPs,
}) => (
  <>
    <GuestRsvpButton
      rsvpStatus="Yes"
      setWipRsvpStatus={setWipRsvpStatus}
      setRsvpOverlayOpen={setRsvpOverlayOpen}
    />
    {shouldShowMaybeRSVPFilter({origin, allowMaybeRSVPs, maybeRSVPCount: null}) && (
      <GuestRsvpButton
        rsvpStatus="Maybe"
        setWipRsvpStatus={setWipRsvpStatus}
        setRsvpOverlayOpen={setRsvpOverlayOpen}
      />
    )}
    <GuestRsvpButton
      rsvpStatus="No"
      setWipRsvpStatus={setWipRsvpStatus}
      setRsvpOverlayOpen={setRsvpOverlayOpen}
    />
  </>
);

export const GuestRsvpActions = ({
  hasRsvpd,
  setUpdatingRsvp,
  setWipRsvpStatus,
  setRsvpOverlayOpen,
  origin,
  allowMaybeRSVPs,
  rsvpDeadline,
  deadlineHasPassed,
  strictRSVPDeadline,
}) => {
  const rsvpDeadlineDate = DateTime.fromISO(rsvpDeadline).toFormat('MMM d');
  const rsvpDeadlineTime = DateTime.fromISO(rsvpDeadline).toFormat('h:mm a');
  const deadlineCopy = strictRSVPDeadline ? 'The deadline to RSVP is' : 'Please RSVP by';

  return deadlineHasPassed && strictRSVPDeadline ? (
    <div className="view-invitation__rsvp-deadline-passed">
      <Typography variant="paragraph1" semibold>
        The RSVP deadline has passed.
      </Typography>
      <Typography variant="paragraph3" color="asphalt">
        Please contact your host to RSVP.
      </Typography>
    </div>
  ) : (
    <div className="view-invitation__rsvp-handler">
      <div className="view-invitation__rsvp-handler__info">
        <Typography variant="paragraph1" semibold>
          Will you be attending?
        </Typography>
        {!!rsvpDeadline && (
          <Typography variant="paragraph3" color="asphalt">
            {deadlineCopy} {rsvpDeadlineDate} at {rsvpDeadlineTime}
          </Typography>
        )}
      </div>
      <div className="view-invitation__rsvp-cta-group">
        <GuestRsvpOriginalButtons
          origin={origin}
          setRsvpOverlayOpen={setRsvpOverlayOpen}
          setWipRsvpStatus={setWipRsvpStatus}
          allowMaybeRSVPs={allowMaybeRSVPs}
        />
      </div>
      {hasRsvpd && (
        <Button
          variant="unstyled-button"
          data-qa-id="cancel-rsvp-change"
          className="unstyled-button link"
          onClick={() => setUpdatingRsvp(false)}
        >
          Cancel
        </Button>
      )}
    </div>
  );
};
